export default __webpack_public_path__ + "KaTeX_Caligraphic-Regular.35f3c951b5a1044753e0eb4183d55103.ttf";